// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__GeVL1","info":"Panel_info__SLeBd","btns":"Panel_btns__wOiL0","button":"Panel_button__bh+M5"};